import React from 'react'
import { Quote, Star } from 'lucide-react'

const AVATAR_COLORS = ['#EA4335', '#4285F4', '#34A853', '#FBBC05', '#9C27B0', '#00ACC1', '#FF7043']

const TESTIMONIALS = [
  {
    quote:
      'Sou enfermeira e cuidadora, a Dra. Samantha, conseguiu aumentar meus atendimentos em Mandaguari e Maringá. Seu método me fez aplicar marketing humanizado de forma personalizada e leve. Obrigada!',
    name: 'Maria Imaculada De Oliveira',
    role: 'Avaliação Google',
    initial: 'M',
  },
  {
    quote:
      'A Dra. Samantha remodelou minha percepção do que é marketing e vendas. Obrigado, por me permitir enxergar novos horizontes. Hoje tenho serviços com valor agregado e com alta percepção de valor.',
    name: 'Jose Alves',
    role: 'Avaliação Google',
    initial: 'J',
  },
  {
    quote:
      'Profissionalismo, competência, capacitação e acolhimento é isso que se resume a agência. Só tenho a agradecer pelo ótimo atendimento que tivemos de todos. Super recomendo.',
    name: 'Vivane Merico',
    role: 'Avaliação Google',
    initial: 'V',
  },
  {
    quote:
      'Empresa sensacional, Samanta com um conhecimento incrível, ajudou muito nossa empresa ser vista, estão de parabéns!',
    name: 'Mafalda Bilk',
    role: 'Avaliação Google',
    initial: 'M',
  },
  {
    quote:
      'Minha experiência foi ótima, me senti muito confortável para trocar ideias, um trabalho humanizado e muito profissional.',
    name: 'Luciane Crozetta',
    role: 'Avaliação Google',
    initial: 'L',
  },
]

function TestimonialCard({ testimonial, avatarColor }) {
  return (
    <div className='w-[78vw] max-w-[340px] flex-shrink-0 rounded-2xl border border-dorac-border bg-dorac-bg p-6 sm:w-[400px] sm:max-w-none sm:p-8'>
      <Quote className='mb-4 h-6 w-6 text-dorac-purple/30 sm:mb-5 sm:h-7 sm:w-7' />
      <p
        className='mb-6 text-xs font-medium leading-relaxed text-dorac-ink/80 sm:mb-7 sm:text-base'
        style={{ minHeight: 110 }}
      >
        &ldquo;{testimonial.quote}&rdquo;
      </p>
      <div className='flex items-start gap-2.5 sm:gap-3'>
        <div
          className='flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full text-xs font-bold text-white sm:h-9 sm:w-9 sm:text-sm'
          style={{ backgroundColor: avatarColor }}
        >
          {testimonial.initial}
        </div>
        <div className='min-w-0 flex-1'>
          <div className='text-xs font-bold leading-snug sm:text-sm'>{testimonial.name}</div>
          <div className='truncate text-[10px] text-dorac-ink/60 sm:text-xs'>{testimonial.role}</div>
          <div className='mt-1 flex gap-0.5 sm:mt-1.5'>
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className='h-3 w-3 fill-current sm:h-3.5 sm:w-3.5' style={{ color: '#FDD663' }} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

function Testimonials() {
  const doubled = [...TESTIMONIALS, ...TESTIMONIALS]

  return (
    <section className='flex flex-col justify-center bg-white py-16 md:py-24 md:min-h-[100dvh]'>
      <div className='container mx-auto px-4'>
        <div className='mb-16 text-center'>
          <span className='section-eyebrow'>Prova social</span>
          <h2 className='section-title mb-4'>O que nossos clientes dizem</h2>
        </div>
      </div>

      <div
        className='relative mx-auto overflow-hidden'
        style={{
          maxWidth: 'min(100vw, calc(400px * 3 + 24px * 2))',
          WebkitMaskImage: 'linear-gradient(90deg, transparent 0%, black 4%, black 96%, transparent 100%)',
          maskImage: 'linear-gradient(90deg, transparent 0%, black 4%, black 96%, transparent 100%)',
        }}
      >
        <div className='flex w-max gap-6' style={{ animation: 'testimonials-marquee 70s linear infinite' }}>
          {doubled.map((testimonial, index) => (
            <TestimonialCard
              key={`${testimonial.name}-${index}`}
              testimonial={testimonial}
              avatarColor={AVATAR_COLORS[(index % TESTIMONIALS.length) % AVATAR_COLORS.length]}
            />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes testimonials-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  )
}

export default Testimonials
